import { addAndTrack } from "../../../calculators/helpers";
import { elmtDmgBnes } from "../../../configs";
import { applyPct, findByCode } from "../../../helpers";
import { Green } from "../../../styledCpns/DataDisplay";
import { NCPApcts } from "../../characters/helpers";
import { wpSimpleAnTmaker } from "../config";
import { LiyueSeries } from "../series";

const GoldSwords = [
  {
    code: 148,
    name: "Light of Foliar Incision",
    icon: "d/de/Weapon_Light_of_Foliar_Incision",
    rarity: 5,
    mainStatScale: "44b",
    subStat: { type: "CRIT DMG", scale: "19.2%" },
    addBnes: wpSimpleAnTmaker("ATTRs", "CRIT Rate", 1),
    pasvName: "Whitemoon Bristle",
    pasvDescs: ({ wpRfm }) => [
      {
        bonus: (
          <>
            <Green>CRIT Rate</Green> is increased by{" "}
            <Green b>{3 + wpRfm}%</Green>.
          </>
        ),
        buff: (
          <>
            When Normal Attacks deal Elemental DMG, the Foliar Incision effect
            will be obtained, increasing{" "}
            <Green>Normal Attack and Elemental Skill DMG</Green> by{" "}
            <Green b>{90 + wpRfm * 30}%</Green> of{" "}
            <Green>Elemental Mastery</Green>. This effect will disappear after
            28 DMG instances or 12s.
          </>
        ),
        other: <>You can obtain Foliar Incision once every 12s.</>
      }
    ],
    buffs: [
      {
        index: 0,
        affect: "self",
        addFinalBnes: ({ ATTRs, hitBnes, wpRfm, tkDesc, tracker }) => {
          const bnValue = ATTRs["Elemental Mastery"] * (0.9 + 0.3 * wpRfm);
          const fields = ["NA.flat", "ES.flat"];
          addAndTrack(tkDesc, hitBnes, fields, bnValue, tracker);
        },
        desc: ({ wpRfm }) =>
          findByCode(GoldSwords, 148).pasvDescs({ wpRfm })[0].buff
      }
    ]
  },
  {
    code: 140,
    name: "Key of Hierophany",
    icon: "5/52/Weapon_Key_of_Khaj-Nisut",
    rarity: 5,
    mainStatScale: "44b",
    subStat: { type: "HP%", scale: "14.4%" },
    addBnes: wpSimpleAnTmaker("ATTRs", "HP%", 5),
    buffs: [
      {
        index: 0,
        affect: "self",
        labels: ["Stacks"],
        inputTypes: ["stacks"],
        values: [3],
        addFinalBnes: ({ ATTRs, wpRfm, inputs, tkDesc, tracker }) => {
          let pct = (0.09 + wpRfm * 0.03) * inputs[0];
          if (inputs[0] === 3) pct += 0.2;
          const bnValue = applyPct(ATTRs.HP, pct);
          const desc = tkDesc + ` / ${pct}% of ${ATTRs.HP} HP`;
          addAndTrack(desc, ATTRs, "Elemental Mastery", bnValue, tracker);
        },
        desc: ({ wpRfm }) => {
          const { buff, others } = findByCode(GoldSwords, 140).pasvDescs({
            wpRfm
          })[0];
          return (
            <>
              {buff} {others}
            </>
          );
        }
      },
      {
        index: 1,
        affect: "teammates",
        labels: ["Max HP"],
        inputTypes: ["text"],
        addBnes: ({ ATTRs, wpRfm, inputs, tkDesc, tracker }) => {
          const bnValue = applyPct(inputs[0], 0.15 + wpRfm * 0.05);
          addAndTrack(tkDesc, ATTRs, "Elemental Mastery", bnValue, tracker);
        },
        desc: ({ wpRfm }) =>
          findByCode(GoldSwords, 140).pasvDescs({ wpRfm })[0].others
      }
    ],
    pasvName: "Sunken Song of the Sands",
    pasvDescs: ({ wpRfm }) => [
      {
        bonus: (
          <>
            <Green>HP</Green> increased by <Green b>{15 + wpRfm * 5}%</Green>.
          </>
        ),
        buff: (
          <>
            When an Elemental Skill hits opponents, you gain the Grand Hymn
            effect for 20s. This effect increases the equipping character's{" "}
            <Green>Elemental Mastery</Green> by <Green b>0.12%</Green> of their{" "}
            <Green>Max HP</Green>. This effect can trigger once every 0.3s. Max{" "}
            <Green b>3</Green> <Green>stacks</Green>.
          </>
        ),
        others: (
          <>
            When Grand Hymn effect gains 3 stacks, or when the third stack's
            duration is refreshed, the <Green>Elemental Mastery</Green> of all
            nearby party members will be increased by <Green b>0.2%</Green> of
            the equipping character's <Green>Max HP</Green> for 20s.
          </>
        )
      }
    ]
  },
  {
    code: 124,
    name: "Haran Geppaku Futsu",
    icon: "8/85/Weapon_Haran_Geppaku_Futsu",
    rarity: 5,
    mainStatScale: 46,
    subStat: { type: "CRIT Rate", scale: "7.2%" },
    addBnes: wpSimpleAnTmaker("ATTRs", elmtDmgBnes, 3),
    buffs: [
      {
        index: 0,
        outdated: true,
        desc: () => (
          <>
            When the character equipping this weapon uses an Elemental Skill,
            all stacks of Wavespike will be consumed to gain Ripping Upheaval.{" "}
            <Green>Each stack</Green> of Wavepike consumed will increase{" "}
            <Green>Normal Attack DMG</Green> by <Green b>8%</Green> for 8s.
          </>
        )
      },
      {
        index: 1,
        affect: "self",
        labels: ["Stacks"],
        inputTypes: ["stacks"],
        values: [2],
        addBnes: ({ hitBnes, wpRfm, inputs, tkDesc, tracker }) => {
          const bnValue = (15 + wpRfm * 5) * inputs[0];
          addAndTrack(tkDesc, hitBnes, "NA.pct", bnValue, tracker);
        },
        desc: ({ wpRfm }) =>
          findByCode(GoldSwords, 124).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "Honed Flow",
    pasvDescs: ({ wpRfm }) => [
      {
        bonus: (
          <>
            Obtain <Green b>{9 + wpRfm * 3}%</Green>{" "}
            <Green>All Elemental DMG Bonus</Green>. When other nearby party
            members use Elemental Skills, the character equipping this weapon
            will gain 1 Wavespike stack. Max <Green b>2</Green>{" "}
            <Green>stacks</Green>. This effect can be triggered once every 0.3s.
          </>
        ),
        buff: (
          <>
            When the character equipping this weapon uses an Elemental Skill,
            all stacks of Wavespike will be consumed to gain Ripping Upheaval.{" "}
            <Green>Each stack</Green> of Wavepike consumed will increase{" "}
            <Green>Normal Attack DMG</Green> by{" "}
            <Green b>{15 + wpRfm * 5}%</Green> for 8s.
          </>
        )
      }
    ]
  },
  {
    code: 101,
    name: "Mistsplitter Reforged",
    icon: "0/09/Weapon_Mistsplitter_Reforged",
    rarity: 5,
    mainStatScale: 48,
    subStat: { type: "CRIT DMG", scale: "9.6%" },
    addBnes: wpSimpleAnTmaker("ATTRs", elmtDmgBnes, 3),
    buffs: [
      {
        index: 0,
        affect: "self",
        labels: ["Stacks"],
        inputTypes: ["stacks"],
        values: [3],
        addBnes: ({ ATTRs, wpRfm, inputs, charData, tkDesc, tracker }) => {
          const field = charData.vision + " DMG Bonus";
          const { stackVal } = findByCode(GoldSwords, 101);
          const bnValue = stackVal({ wpRfm })[inputs[0] - 1];
          addAndTrack(tkDesc, ATTRs, field, bnValue, tracker);
        },
        desc: ({ wpRfm }) =>
          findByCode(GoldSwords, 101).pasvDescs({ wpRfm })[0].buff
      }
    ],
    stackVal: ({ wpRfm }) => [6 + wpRfm * 2, 12 + wpRfm * 4, 21 + wpRfm * 7],
    pasvName: "Mistsplitter's Edge",
    pasvDescs: ({ wpRfm }) => [
      {
        bonus: (
          <>
            Gain a <Green b>{9 + wpRfm * 3}%</Green>{" "}
            <Green>Elemental DMG Bonus</Green> for every element and receive the
            might of Mistsplitter's Emblem.
          </>
        ),
        buff: (
          <>
            At stack levels 1/2/3, Mistsplitter's Emblem provides a{" "}
            <Green b>
              {findByCode(GoldSwords, 101).stackVal({ wpRfm }).join("/")}%
            </Green>{" "}
            Elemental DMG Bonus for the{" "}
            <Green>character's Elemental Type</Green>.
          </>
        ),
        others: (
          <>
            The character will obtain 1 stack of Mistsplitter's Emblem in each
            of the following scenarios: Normal Attack deals Elemental DMG (stack
            lasts 5s), casting Elemental Burst (stack lasts 10s); Energy is less
            than 100% (stack disappears when Energy is full). Each stack's
            duration is calculated independently.
          </>
        )
      }
    ]
  },
  {
    code: 102,
    name: "Aquila Favonia",
    icon: "6/6a/Weapon_Aquila_Favonia",
    rarity: 5,
    mainStatScale: 48,
    subStat: { type: "Physical DMG Bonus", scale: "9%" },
    addBnes: wpSimpleAnTmaker("ATTRs", "ATK%", 5),
    pasvName: "Falcon's Defiance",
    pasvDescs: ({ wpRfm }) => [
      {
        bonus: (
          <>
            <Green>ATK</Green> is increased by{" "}
            <Green b>{15 + wpRfm * 5}%</Green>. Triggers on taking DMG: the soul
            of the Falcon of the West awakens, holding the banner of the
            resistance aloft, regenerating HP equal to {85 + wpRfm * 15}% of ATK
            and dealing <Green b>{160 + wpRfm * 40}%</Green>
            of <Green>ATK</Green> as DMG to surrounding opponents. This effect
            can only occur once every 15s.
          </>
        )
      }
    ]
  },
  {
    code: 103,
    name: "Skyward Blade",
    icon: "0/03/Weapon_Skyward_Blade",
    rarity: 5,
    mainStatScale: 46,
    subStat: { type: "Energy Recharge", scale: "12%" },
    addBnes: wpSimpleAnTmaker("ATTRs", "CRIT Rate", 1),
    buffs: [
      {
        index: 0,
        affect: "self",
        addBnes: ({ ATTRs, wpRfm, tkDesc, tracker }) => {
          const fields = ["Normal ATK SPD", "Charged ATK SPD"];
          addAndTrack(tkDesc, ATTRs, fields, 10, tracker);
        },
        desc: ({ wpRfm }) =>
          findByCode(GoldSwords, 103).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "Sky-Piercing Fang",
    pasvDescs: ({ wpRfm }) => [
      {
        bonus: (
          <>
            <Green>Crit Rate</Green> increased by <Green b>{3 + wpRfm}%</Green>.
            And Normal and Charged hits deal additional DMG equal to{" "}
            <Green b>{15 + wpRfm * 5}%</Green> of ATK. Skypiercing Might lasts
            for 12s.
          </>
        ),
        buff: (
          <>
            Gains Skypiercing Might upon using Elemental Burst: Increases
            Movement SPD and <Green>ATK SPD</Green> by <Green b>10%</Green>.
          </>
        ),
        others: <></>
      }
    ]
  },
  {
    code: 104,
    name: "Freedom-Sworn",
    icon: "3/39/Weapon_Freedom-Sworn",
    rarity: 5,
    mainStatScale: 46,
    subStat: { type: "Elemental Mastery", scale: 43 },
    addBnes: wpSimpleAnTmaker("hitBnes", "All.pct", 2.5),
    buffs: [
      {
        index: 0,
        affect: "party",
        addBnes: ({ ATTRs, hitBnes, wpRfm, tkDesc, tracker }) => {
          addAndTrack(tkDesc, hitBnes, NCPApcts, 12 + wpRfm * 4, tracker);
          addAndTrack(tkDesc, ATTRs, "ATK%", 15 + wpRfm * 5, tracker);
        },
        desc: ({ wpRfm }) =>
          findByCode(GoldSwords, 104).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "Revolutionary Chorale",
    pasvDescs: ({ wpRfm }) => [
      {
        bonus: (
          <>
            A part of the "Millennial Movement" that wanders amidst the winds.
            Increases <Green>DMG</Green> by{" "}
            <Green b>{7.5 + wpRfm * 2.5}%</Green>. When triggering Elemental
            Reactions, the character gains a Sigil of Rebellion. This effect can
            be triggered once every 0.5s. When you possess 2 Sigils of
            Rebellion, all of them will be consumed and all nearby party members
            will obtain the "Millennial Movement: Song of Resistance" effect for
            12s.
          </>
        ),
        buff: (
          <>
            "Millennial Movement: Song of Resistance" increases{" "}
            <Green>Normal, Charged, and Plunging Attack DMG</Green> by{" "}
            <Green b>{12 + wpRfm * 4}%</Green> and increases <Green>ATK</Green>{" "}
            by <Green b>{15 + wpRfm * 5}%</Green>. Once this effect is
            triggered, you will not gain Sigils of Rebellion for 20s.
          </>
        ),
        others: (
          <>
            Of the many effects of the "Millennial Movement", buffs of the same
            type will not stack.
          </>
        )
      }
    ]
  },
  {
    code: 105,
    name: "Summit Shaper",
    icon: "c/ca/Weapon_Summit_Shaper",
    rarity: 5,
    mainStatScale: 46,
    subStat: { type: "ATK%", scale: "10.8%" },
    ...LiyueSeries
  },
  {
    code: 106,
    name: "Primordial Jade Cutter",
    icon: "2/2a/Weapon_Primordial_Jade_Cutter",
    rarity: 5,
    mainStatScale: "44b",
    subStat: { type: "CRIT Rate", scale: "9.6%" },
    addBnes: wpSimpleAnTmaker("ATTRs", "HP%", 5),
    addFinalBnes: ({ ATTRs, wpRfm, tkDesc, tracker }) => {
      const bnPct = 0.9 + wpRfm * 0.3;
      const bnValue = applyPct(ATTRs.HP, bnPct);
      const xDesc = ` / ${bnPct}% of ${ATTRs.HP} HP`;
      addAndTrack(tkDesc + xDesc, ATTRs, "ATK", bnValue, tracker);
    },
    pasvName: "Protector's Virtue",
    pasvDescs: ({ wpRfm }) => [
      {
        bonus: (
          <>
            <Green>HP</Green> increased by <Green b>{15 + wpRfm * 5}%</Green>.
            Additionally, provides an <Green>ATK Bonus</Green> based on{" "}
            <Green b>{(9 + wpRfm * 3) / 10}%</Green> of the wielder's{" "}
            <Green>Max HP</Green>.
          </>
        )
      }
    ]
  }
];

export default GoldSwords;
